export function contact() {
  // フォーム送信時の処理
  var submitButton = document.querySelector("input[type='submit']");
  if (submitButton) {
    submitButton.addEventListener("click", function () {
      // 各フィールドの値を取得
      var schoolValue = document.getElementById("your-school").value;
      var departmentValue = document.getElementById("your-department").value;
      var facultyValue = document.getElementById("your-faculty").value;
      var yearValue = document.getElementById("your-year").value;

      // バリデーションチェック
      if (schoolValue === "") {
        document.getElementById("your-school-error").style.display = "block";
      } else {
        document.getElementById("your-school-error").style.display = "none";
      }

      if (departmentValue === "") {
        document.getElementById("your-department-error").style.display = "block";
      } else {
        document.getElementById("your-department-error").style.display = "none";
      }

      if (facultyValue === "") {
        document.getElementById("your-faculty-error").style.display = "block";
      } else {
        document.getElementById("your-faculty-error").style.display = "none";
      }

      if (yearValue === "") {
        document.getElementById("your-year-error").style.display = "block";
      } else {
        document.getElementById("your-year-error").style.display = "none";
      }
    });
  }
}
